import { useFormContext } from 'react-hook-form'
import _ from 'lodash'

import { CardContentContainer } from './Card'
import { SliderRange, SliderRoot, SliderThumb, SliderTrack } from '../../../components/ReactSlider/ReactSlider'
import {
  TooltipArrow,
  TooltipContent,
  TooltipRoot,
  TooltipTrigger
} from '../../../components/ReactTooltip/ReactTooltip'
import { onboardingJson as onboardingProcessDataSrc } from './onboarding-process.js'
import styles from './OnboardingSlider.module.css'

const OnboardingSlider = (props) => {
  // props
  const { defaultTooltipOpen, isTooltipOpen, onChangeCount } = props

  // forms
  const { watch } = useFormContext()
  const count = watch('count')
  const reasonForUsingBot = watch('reasonForUsingBot')

  const countFor = reasonForUsingBot?.trackOf ? _.upperFirst(`${reasonForUsingBot.trackOf}s`) : ''

  const onSliderValueChange = (value) => {
    onChangeCount(value[0])
  }

  return (
    <CardContentContainer {...props} className={styles.SliderComponent}>
      <div className={styles.SliderContainer}>
        <SliderRoot
          defaultValue={[count]}
          min={onboardingProcessDataSrc.slider.min}
          max={onboardingProcessDataSrc.slider.max}
          step={onboardingProcessDataSrc.slider.steps}
          onValueChange={onSliderValueChange}
          aria-label='Volume'
          className='custom-slider'
        >
          <SliderTrack>
            <SliderRange />
          </SliderTrack>
          <TooltipRoot delayDuration={0} defaultOpen={defaultTooltipOpen} open={isTooltipOpen}>
            <TooltipTrigger asChild>
              <SliderThumb />
            </TooltipTrigger>
            <TooltipContent className={styles.TooltipLabel} sideOffset={15} side='top'>
              {count}
              <TooltipArrow />
            </TooltipContent>
          </TooltipRoot>
        </SliderRoot>
        <div className={styles.SliderHelpTextContainer}>
          <span> 100 {countFor} </span>
          <span>
            {onboardingProcessDataSrc.slider.max}+ {countFor}
          </span>
        </div>
      </div>
    </CardContentContainer>
  )
}

export default OnboardingSlider
